import { InjectionToken } from '@angular/core';

import { EnvironmentModel } from './environment.model';

export const ENVIRONMENT: InjectionToken<EnvironmentModel> = new InjectionToken(
  'ENVIRONMENT',
);
